module.exports = __webpack_public_path__ + "img/28.e6719046.jpg";